import posthog from 'posthog-js';

export const initPostHog = () => {
  posthog.init('phc_j6YeoqLCrMN7AWfXn897XVnhIiwDtcsBZSfNiNRsjPr', { api_host: 'https://eu.i.posthog.com', person_profiles: 'identified_only' })
};